<script>
import {mapState} from "vuex";
import i18n from "@/i18n";
import axios from "axios";
import {query} from "sinao-corejs";
import SearchResultTeaser from "@/components/CreateOrganization/SearchResultTeaser.vue";
import {fetchDirectINSEE, formatDirectINSEEaddress} from "@/mixins/insee";

export default {
  components: {
    SearchResultTeaser,
  },
  props: {
  },
  data() {
    return {
      modalRefName: "ModalCreateOrganizationApiContent",
      enableOpenDataSoft: true,
      publicJuridicCodes: ['0', '4', '7'],
      automatic_mode: true,
      suggested_place: null,
      name: '',
      postal_code: '',
      address: '',
      siren: '',
      country: 'FR',
      legal_form: '',
      vat: '',
      search_loading: false,
      resultSearch:[],
      loading_creation: false,
      chorusToken: {
        data: '',
        expire: (new Date()).getTime() // expire now
      },
      $_debounceTimer: null,
      lastName: null,
      lastPostalCode: null,
      lastAdresse: null,
      lastSiren: null
    };
  },
  computed: {
    ...mapState({
      appId: state => state.app.id,
      token: state => state.app.token,
      isThirdAccountGlobal: state => state.contacts.isThirdAccountGlobal
    })
  },
  mounted() {
  },
  methods: {
    async searchINSEE() {
      let search = (this.siren?.length >= 9) ? this.siren : (this.name?.length > 0 ? this.name : "");

      if (this.postal_code && String(this.postal_code).length > 0) {
        search += ( (search.length ? " " : "") + String(this.postal_code));
      }

      if (this.address?.length > 0) {
        search += ((search.length ? " " : "") + this.address);
      }

      if (search.length < 3)
        return;

      this.search_loading = true;
      this.loading_creation = true;
      try {
        const url = `https://data.opendatasoft.com/api/records/1.0/search/?dataset=economicref-france-sirene-v3%40public&q=${encodeURIComponent(search)}&timezone=Europe%2FParis&refine.etatadministratifetablissement=Actif&refine.etablissementsiege=oui`;
        const response = await axios.get(url);
        if (!parseInt(response.status) === 200) {
          throw new Error('Network response was not ok');
        }
        this.resultSearch = response.data?.records?.length ? response.data.records : []
      } catch (error) {
        console.error(error);
      }
      this.loading_creation = false;
      this.search_loading = false;
    },
    async searchBillingNameInChorus(national_id) { // return null | string as billing name
      // check chorusToken and reset if expired
      this.chorusToken.data = this.chorusToken.data.length
          ? (this.chorusToken.expire >= ( new Date()).getTime() ? this.chorusToken.data : '' )
          : '';

      const body = {
        national_id: national_id, // do not search until siren is completed
        token: this.chorusToken.data.length ? (this.chorusToken.expire >= (new Date()).getTime() ? this.chorusToken.data : '' ) : ''
      };
      // if empty params do nothing
      if (Object.values(body).find(param_val => param_val.length > 0) === undefined) return null;

      // call endpoint
      try {
        const response = await query({
          operationId: 'app.payments.choruspro.get_structure_billing_name',
          params: {},
          body: body
        });
        // update chorusToken
        if (this.chorusToken.data.length === 0 && response.token?.length > 0) {
          this.chorusToken.data = response.token;
          this.chorusToken.expire =  (new Date()).getTime() + (1000 * 60 * 10); //expire in 10 minutes
        }
        return response.billing_name;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    async selectOrganization(record) {

      this.loading_creation= true;

      const organization_name = record?.fields?.nomunitelegale ?? record?.fields?.denominationunitelegale ?? record?.uniteLegale?.denominationUniteLegale ?? record?.uniteLegale?.nomUniteLegale ?? '';
      const national_id = record?.fields?.siren ?? record.siren;
      let billing_name = organization_name;

      // detect public entity
      const code_first_letter = String(record?.uniteLegale?.categorieJuridiqueUniteLegale ?? record?.fields?.categoriejuridiqueunitelegale ?? 'null').substring(0, 1);
      if ( (this.publicJuridicCodes.find(publicCode => publicCode === code_first_letter ) !== undefined) && national_id?.length) {
        // searchChorus to get billing name
        billing_name = await this.searchBillingNameInChorus(national_id) ?? billing_name;
      }
      try {
        const created_organization = await query({
          operationId: "app.contacts.organizations.create",
          token: this.token,
          params: {
            'appId': this.appId,
            'expand[0]': 'establishments',
            'expand[1]': 'establishments.contacts',
          },
          data: {
            name: organization_name,
            billing_name: billing_name,
            national_id: national_id,
            country_iso2: "FR",
          }
        });

        if (record.adresseEtablissement) {
          let formData = new FormData()
          if (record.adresseEtablissement.numeroVoieEtablissement) formData.append('place[street_number]', record.adresseEtablissement.numeroVoieEtablissement)
          if (formatDirectINSEEaddress(record, false))  formData.append('place[route]', formatDirectINSEEaddress(record, false))
          if (record.adresseEtablissement.complementAdresseEtablissement)  formData.append('place[route2]', record.adresseEtablissement.complementAdresseEtablissement)
          if (record.adresseEtablissement.codePostalEtablissement) formData.append('place[postal_code]', record.adresseEtablissement.codePostalEtablissement)
          if (record.adresseEtablissement.libelleCommuneEtablissement)  formData.append('place[locality]', record.adresseEtablissement.libelleCommuneEtablissement)
          formData.append('place[country]', 'FRANCE')

          const updated_establishment = await query({
            operationId: "app.contacts.establishments.update",
            token: this.token,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            params: {
              'appId': this.appId,
              'id': created_organization.establishments[0].id,
              'expand[0]': 'contacts',
            },
            data: formData
          });
          created_organization.establishments[0] = Object.assign({}, updated_establishment)
        }

        this.$bvToast.toast(i18n.t('Success_contact_add'), {
          variant: "success",
          solid: true
        });

        this.$store.commit('updateContactInfos', { data: created_organization, target: this.isThirdAccountGlobal === true ? 'thirdAccount' : 'contactInfos' });

        this.resetForm();
        // close parent dialog
        this.$nextTick(() => {
          this.$emit("close");
        });
      } catch (error) {
        console.error(error);
        this.loading_creation = false;
      }
    },
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
    debouncedName () {
      this.debounce(async () => {
        if (this.name !== this.lastName) {
          this.lastName = this.name;
          this.enableOpenDataSoft ? await this.searchINSEE() : this.searchDirectINSEE();
        }
      }, 200);
    },
    debouncedPostalCode() {
      this.debounce(async () => {
        if (this.postal_code !== this.lastPostalCode) {
          this.lastPostalCode = this.postal_code;
          this.enableOpenDataSoft ? await this.searchINSEE() : this.searchDirectINSEE();
        }
      }, 200);
    },
    debouncedAdresse() {
      this.debounce(async () => {
        if (this.address !== this.lastAdresse) {
          this.lastAdresse = this.address.value;
          this.enableOpenDataSoft ? await this.searchINSEE() : this.searchDirectINSEE();
        }
      }, 200);
    },
    debouncedSiren() {
      this.debounce(async () => {
        if (this.siren !== this.lastSiren) {
          this.lastSiren = this.siren;
          this.searchDirectINSEE();
        }
      }, 200);
    },
    searchDirectINSEE() {
      this.debounce( async () => {
        this.search_loading = true;

        let q = "";
        if (this.name?.length) {
          if (!isNaN(this.name)) {
            this.siren = this.name;
            this.name = '';
          } else {
            q = `denominationUniteLegale:"${this.name.trim()}"`;
          }
        }

        const new_siren = this.siren?.replace(/[^\d]/g, '') ?? '';
        if (new_siren.length >= 9) {
          this.loading_creation = true;
          const json = await fetchDirectINSEE(`${new_siren.length == 9 ? 'siren:' : 'siret:'}${new_siren}`);
          console.log("response direct Insee", json);
          this.loading_creation = false;

          this.resultSearch = [];
          if (json.data?.etablissements?.length)
            this.resultSearch = json.data.etablissements.filter((m, index, self) => self.findIndex(t => t.siren === m.siren) === index);
          this.search_loading = false;
          return;
        }

        if (String(this.postal_code)?.length) {
          q += q.length ? ` AND codePostalEtablissement:${parseInt(this.postal_code)}` : `codePostalEtablissement:${parseInt(this.postal_code)}`;
        }

        if (this.address?.length) {
          q += q.length ? ` AND (libelleCommuneEtablissement:"${this.address}" OR libelleVoieEtablissement:"${this.address}")` : `(libelleVoieEtablissement:"${this.address}" OR libelleCommuneEtablissement:"${this.address}")`;
        }

        if (q.length) {
          q += " AND etablissementSiege:true";
          this.loading_creation = true;
          const json = await fetchDirectINSEE(q);
          this.loading_creation = false;
          this.resultSearch = json.etablissements.filter((m, index, self) => self.findIndex(t => t.siren === m.siren) === index);
        } else {
          this.resultSearch = [];
        }

        this.search_loading = false;
      }, 200);
    },
    resetForm() {
      this.name = '';
      this.postal_code = '';
      this.address = '';
      this.siren = '';
      this. loading_creation = false;
      this.lastName = null;
      this.lastPostalCode = null;
      this.lastAdresse = null;
      this.lastSiren = null;
      this.resultSearch = [];
    },
    openManualContent() {
      this.$store.commit("resetEditableEstablishment")
      this.$emit('update:mode', false);
    }
  }
};
</script>

<template>
  <form
      ref="form_auto"
  >
    <b-container>
      <b-row>
        <b-col cols="12" class="px-1">
          <div class="d-flex flex-row">
            <div class="bg-primary rounded-circle icon_square icon_small mr-2" style="background-color: var(--primary)">
              <div class="text-center text-white text_icon">1</div>
            </div>
            <div class="flex-grow-1">
              <b-form-input
                  v-model="name"
                  size="sm"
                  :placeholder="$t('Nom (raison sociale)')"
                  @keyup="debouncedName"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12" class="px-1">
          <div class="d-flex flex-row">
            <div class="rounded-circle icon_square icon_small mr-2" style="background-color: var(--primary)">
              <div class="text-center text-white text_icon">2</div>
            </div>
            <div class="flex-grow-1">
              <b-form-input
                  v-model="postal_code"
                  size="sm"
                  :placeholder="$t('Code postal')"
                  @keyup="debouncedPostalCode"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12" class="px-1">
          <div class="d-flex flex-row">
            <div class="bg-primary rounded-circle icon_square icon_small mr-2">
              <div class="text-center text-white text_icon">3</div>
            </div>
            <div class="flex-grow-1">
              <b-form-input
                  v-model="address"
                  size="sm"
                  :placeholder="$t('Adresse')"
                  @keyup="debouncedAdresse"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12" class="px-1">
          <div class="d-flex flex-row">
            <div class="mr-2 px-1">
              <div class="text-center text_or">{{ $t("OU") }}</div>
            </div>
            <div class="flex-grow-1">
              <hr style="margin-top: 0.6rem">
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="12" class="px-1">
          <div class="d-flex flex-row">
            <div class="bg-primary rounded-circle icon_square icon_small mr-2">
              <div class="text-center text-white text_icon">1</div>
            </div>
            <div class="flex-grow-1">
              <b-form-input
                  v-model="siren"
                  size="sm"
                  :placeholder="$t('Numéro SIREN / SIRET')"
                  @keyup="debouncedSiren"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- list of results -->
      <b-row class="mt-3">
        <b-col class="overflow-auto p-3" style="background-color: #f4f6f9; border-radius: 0.5rem; max-height: 14rem">
          <div v-if="!search_loading && resultSearch.length > 0">
            <div v-if="loading_creation" class="bg-white px-4 py-2 cursor-pointer" style="display: flex; justify-content: center; align-items: center; height: 68px;">
              <b-spinner variant="secondary" small />
            </div>

            <SearchResultTeaser
                v-for="(record, index) in resultSearch"
                v-else
                :key="index"
                :record="record"
                @selected="selectOrganization"
            />
          </div>
          <div v-else-if="search_loading" class="text-center py-2">
            <b-spinner variant="secondary" small />
          </div>
          <div v-else-if="resultSearch.length == 0" class="text-center py-2">
            {{ $t('Empty_result') }}
          </div>
        </b-col>
      </b-row>
      <!-- creation manuelle -->
      <b-row class="mt-4">
        <b-col cols="12" class="px-1 text-right">
          <span class="text-muted text-xs">{{ $t('Entreprise introuvable ?') }}</span>
          <a
              class="h-4 text-xs p-0 pl-1 text-primary text-xs cursor-pointer"
              @click="openManualContent"
          >
            {{ $t('Créer une entreprise manuellement') }}
          </a>
        </b-col>
      </b-row>
    </b-container>
  </form>
</template>

<style scoped lang="scss">

</style>